import { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { formatCurrency } from '../../../common/Helper';
import MonthPicker from './MonthPicker';

const DividendsCalendar = (props) => {

	const { dividends } = props;

	const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1)
	const [filteredDividends, setFilteredDividends] = useState(dividends?.filter(d => d.month === currentMonth))

	useEffect(() => {
		setFilteredDividends(currentMonth === 13 ? dividends : dividends.filter(d => d.month === currentMonth))
	}, [currentMonth])

	const columns = [
		{ field: 'day', headerName: 'Dia'}, 
		{ field: 'market', headerName: 'Mercado'}, 
		{ 
			field: 'stockTicker', 
			headerName: 'Ticker', 
			renderCell: (cellValues) => {	
				return <a href={`/company/${cellValues.row.stockTicker}`}>{cellValues.row.stockTicker}</a>;
			}
		},
		{ 
			field: 'earnings', 
			headerName: 'Valor', 
			width : 200,
			renderCell: (cellValues) => {
				return ( formatCurrency(cellValues.row.earnings, 'SMALL') + (cellValues.row.market === 'US' ? ' ('+ formatCurrency(cellValues.row.originalValue, 'SMALL', 'USD') +')' : '') )
			}
		}  
	]

	return (
		<Grid container spacing={2} margin={1} marginLeft={0}>
			<Grid item xs={12} md={2}>
				<MonthPicker dividends={dividends} onChange={month => setCurrentMonth(month)}/>
			</Grid>
			<Grid item xs={12} md={10}>
				<DataGrid
					getRowId={(row) => row.key} 
					rows={filteredDividends}
					columns={columns}
					pageSize={20}
					rowHeight={30}
					getRowClassName={(params) => {
						let currentMonth = new Date().getMonth() + 1
						let currentDay = new Date().getDate()

						if (params.row.day === currentDay && params.row.month === currentMonth) {
							return 'dividends-grid-current'
						}
						else if ((params.row.day < currentDay && params.row.month === currentMonth) || params.row.month < currentMonth)
							return 'dividends-grid-past'
						else {
							return 'dividends-grid-future'
						}
					}}
					sx={{
						boxSizing: 'border-box',
						width: 'calc(100% - 32px)',
						'& .dividends-grid-past' : {
							backgroundColor : "lightgray",
							opacity : 0.75
						},
						'& .dividends-grid-current' : {
							backgroundColor : "gray",
							fontWeight : 600
						},
						'& .dividends-grid-future' : {
							backgroundColor : "white",
						}
					}}
				/>
			</Grid>
		</Grid>
	)
}

export default DividendsCalendar;